import { withInstall } from '@tav-ui/utils/with-install'
import FileVersion from './index.vue'

export * from './types'
export const TaFileVersion = withInstall(FileVersion)
export default TaFileVersion
